import { Component, ViewChild, OnInit, Output, Input, HostListener, EventEmitter, ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global } from '../../../shared/global';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_tinhchatnguonkp, Lists_manguonnsnn, Lists_caphat, tiens_rutdutoan_giaonhanhoso } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
  selector: 'app-tonghop-hosochungtuedit',
  templateUrl: './hosochungtuedit.component.html',
  //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./hosochungtuedit.component.scss'],
  providers: [ListService, Repository]
})


export class hosochungtueditComponent implements OnInit {

  public loaimaus: any = [
    { Id: 1, Ten: "Giấy rút dự toán ngân sách nhà nước (Mẫu 16a1)" },
    { Id: 2, Ten: "Giấy rút dự toán ngân sách nhà nước (Mẫu 16a2)" },
    { Id: 3, Ten: "Ủy nhiệm chi: C4-02a/KB" },
    { Id: 4, Ten: "Ủy nhiệm chi: C4-02c/KB" },
    { Id: 5, Ten: "Bảng kê chứng từ thanh toán/tạm ứng (M01)" },
    { Id: 6, Ten: "Giấy đề nghị thanh toán tạm ứng (C2-03)" },
    { Id: 7, Ten: "Giấy nộp trả kinh phí (C2-05a)" },

  ];

  public chon2s: any = [
    { Id: '0', Ten: "Tài khoản 3521" },
    { Id: '1', Ten: "Tài khoản 3522" },
    { Id: '2', Ten: "Tài khoản 3523" },
    { Id: '3', Ten: "Tài khoản 3529" },
  ];


  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;

  inputparents: any;
  inputtinhchats: any;
  inputmanguons: any;
  inputcapphats: any;
  indLoading: boolean = false;
  doituongSelect: any = {
    Id: null, Chung_Tu_Id: null, LoaiMau: null, HoSoId: null, v_ma_ho_so_chi_tiet_mau: null, Ma_Chung_Tu: null
    , ThamSo: null, TaiKhoan: null, MoRong_char_1: null,
    MoRong_char_2: null, MoRong_guid_1: null, MoRong_guid_2: null, MoRong_int_1: null, MoRong_int_2: null
    , So_Chung_Tu: null, Ngay_Chung_Tu: null, Ngay_Ghi_So: null, Dien_Giai: null, PhanHe: null, Phan_He_Id: null
    , LoaiMauS: null, Tong_Tien: null
  };
  nhomdtid: string = null;
  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };


  @ViewChild('modaldanhsachhosodoituong', { static: false }) modaldanhsachhosodoituong: ModalComponent;

  @ViewChild('ctdanhsachhosodoituongedit', { static: false }) ctdanhsachhosodoituongedit: any;


  @ViewChild('slCapTren', { static: false }) slCapTren: NgSelectComponent;
  @ViewChild('slTinhChat', { static: false }) slTinhChat: NgSelectComponent;
  @ViewChild('slMaNguon', { static: false }) slMaNguon: NgSelectComponent;
  @ViewChild('slCapPhat', { static: false }) slCapPhat: NgSelectComponent;
  @Output() save: EventEmitter<any> = new EventEmitter();



  constructor(private _dataService: ListService, private repo: Repository) {


  }

  ngOnInit(): void {

  }

  // @HostListener('document:keydown', ['$event'])
  // public handleKeyboardEvent(event: KeyboardEvent): void {

  //   if(event.key==="F9")
  //   {
  //       this.saveproduct();
  //   }
  //   event.stopPropagation();

  // }

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;

  loadDataInit(nhomdoituongid: string, row: any, donviid: string) {

    var authlogin = localStorage.getItem('currentUser');
    if (authlogin) {

      let data = JSON.parse(authlogin);
      var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
    }

    this.nhomdtid = nhomdoituongid;
    //setTimeout(() => {
    //  this.mafocus.nativeElement.focus();
    //}, 500);
    


    this.doituongSelect = {
      Id: null, Chung_Tu_Id: null, LoaiMau: null, HoSoId: null, v_ma_ho_so_chi_tiet_mau: null, Ma_Chung_Tu: null
      , ThamSo: null, TaiKhoan: null, MoRong_char_1: null,
      MoRong_char_2: null, MoRong_guid_1: null, MoRong_guid_2: null, MoRong_int_1: null, MoRong_int_2: null
      , So_Chung_Tu: null, Ngay_Chung_Tu: null, Ngay_Ghi_So: null, Dien_Giai: null, PhanHe: null, Phan_He_Id: null
      ,LoaiMauS: null, Tong_Tien: null
    };

    if (row == null || row.Id==null) {
      
    }
    else {
      console.log(row.Id);
      this.repo.getRequest("api/dvcapi/getbyid_chungtuhoso/" + row.Id)
        .subscribe(response => {
          //console.log(response);
          this.doituongSelect.Id = row.Id;
          this.doituongSelect.LoaiMau = response.LoaiMau;
          this.doituongSelect.HoSoId = response.HoSoId;
          this.doituongSelect.v_ma_ho_so_chi_tiet_mau = response.v_ma_ho_so_chi_tiet_mau;
          this.doituongSelect.ThamSo = response.ThamSo;
          this.doituongSelect.LoaiMauS = response.LoaiMauS;
          

          this.doituongSelect.TaiKhoan = response.TaiKhoan;
          this.doituongSelect.MoRong_char_1 = response.MoRong_char_1;
          this.doituongSelect.MoRong_char_2 = response.MoRong_char_2;
          this.doituongSelect.MoRong_guid_1 = response.MoRong_guid_1;
          this.doituongSelect.MoRong_guid_2 = response.MoRong_guid_2;
          this.doituongSelect.MoRong_int_1 = response.MoRong_int_1;
          this.doituongSelect.MoRong_int_2 = response.MoRong_int_2;


          this.doituongSelect.Chung_Tu_Id = response.Chung_Tu_Id;
          this.doituongSelect.Ma_Chung_Tu = response.Ma_Chung_Tu;
          this.doituongSelect.Tong_Tien = response.Tong_Tien;
          this.doituongSelect.So_Chung_Tu = response.So_Chung_Tu;
          this.doituongSelect.Dien_Giai = response.Dien_Giai;
          this.doituongSelect.PhanHe = response.PhanHe;
          this.doituongSelect.Phan_He_Id = response.Phan_He_Id;

          if (response.Ngay_Chung_Tu != null)
            this.doituongSelect.Ngay_Chung_Tu = new Date(response.Ngay_Chung_Tu);
          if (response.Ngay_Ghi_So != null)
            this.doituongSelect.Ngay_Ghi_So = new Date(response.Ngay_Ghi_So);
        });
    }


  }

  keyTenPress(event: any) {
    if (event.which === 13) {
      this.slCapTren.focus();
      event.preventDefault();
    }
  }
  public closeModal() {
    this.save.emit(null);
  }
  public saveproduct() {
    if (this.doituongSelect.Chung_Tu_Id == null || this.doituongSelect.Chung_Tu_Id == "") {
      swal('Lỗi!', 'Vui lòng chọn chứng từ YCTT!.', 'error');
      return;
    }
    if (this.doituongSelect.LoaiMau == null || this.doituongSelect.LoaiMau == "") {
      swal('Lỗi!', 'Vui lòng chọn loại chứng từ YCTT!.', 'error');
      return;
    }
    if (this.doituongSelect.LoaiMau == 7) {
      if (this.doituongSelect.TaiKhoan == null || this.doituongSelect.TaiKhoan == "") {
        swal('Cảnh báo!', "Tài khoản không được trống", 'warning');
        return;
      }
    }

    this.save.emit(this.doituongSelect);

    //console.log(this.doituongSelect);
    //this.repo.postRequest("api/dvcapi/addorupdate", this.doituongSelect)
    //  .subscribe(response => {
    //    console.log(response);
    //    if (response.indexOf("-") !== -1) {
    //      this.doituongSelect.Id = response;
    //    }
    //    else
    //      swal('Lỗi!', response, 'error');
    //  });


  }

  adddata() {
    let nam: any;
    //if (this.thoigiankhen != null)
    //  nam = this.thoigiankhen.getFullYear();
    this.ctdanhsachhosodoituongedit.loadDataInit(null, tiens_rutdutoan_giaonhanhoso.id);
    this.modaldanhsachhosodoituong.open();

  }
  savedsdoituong(doituong1: any) {
    //console.log("save dt chọn chứng từ");
    //console.log(doituong1);

    if (doituong1 != null) {
      let doituong = doituong1[0];

      this.doituongSelect.Chung_Tu_Id = doituong.Id;
      this.doituongSelect.Ma_Chung_Tu = doituong.So_Chung_Tu;
      this.doituongSelect.Tong_Tien = doituong.Tong_Tien;
      this.doituongSelect.So_Chung_Tu = doituong.So_Chung_Tu;
      this.doituongSelect.Dien_Giai = doituong.Dien_Giai;
      this.doituongSelect.PhanHe = doituong.PhanHe;
      //this.doituongSelect.Phan_He_Id = doituong.Phan_He_Id;

      if (doituong.Ngay_Chung_Tu != null)
        this.doituongSelect.Ngay_Chung_Tu = new Date(doituong.Ngay_Chung_Tu);
      if (doituong.Ngay_Ghi_So != null)
        this.doituongSelect.Ngay_Ghi_So = new Date(doituong.Ngay_Ghi_So);
      //doituong.forEach(
      //  (item) => {
      //    let row = {
      //      Id: item.Id, MaNV: item.MaNV, HoVaTen: item.HoVaTen
      //      , Ngay: item.Ngay, GioiTinh: item.GioiTinh, SoCMND: item.SoCMND
      //      , PhongBan: item.PhongBan, DonVi: item.DonVi
      //      , DanhHieu: null
      //      , DanhHieuId: null
      //      , NoiDung: null
      //      , SoSangKien: null
      //      , SoTien: null
      //    }
       
      //  }
      //);
     
      
    }
    this.modaldanhsachhosodoituong.close();
  }
  onDoiTuongChange($event) {

    if (typeof $event === "undefined") {
      this.doituongSelect.LoaiMauS = null;
    }
    else {
      if ($event.Id == 1)
        this.doituongSelect.LoaiMauS = "Giấy rút dự toán ngân sách nhà nước (Mẫu 16a1)";
      if ($event.Id == 2)
        this.doituongSelect.LoaiMauS = "Giấy rút dự toán ngân sách nhà nước (Mẫu 16a2)";
      if ($event.Id == 3)
        this.doituongSelect.LoaiMauS = "Ủy nhiệm chi: C4-02a/KB";
      if ($event.Id == 4)
        this.doituongSelect.LoaiMauS = "Ủy nhiệm chi: C4-02c/KB";
      if ($event.Id == 5) {
        this.doituongSelect.LoaiMauS = "Bảng kê chứng từ thanh toán/tạm ứng (M01)";
        this.doituongSelect.Ma_Chung_Tu = "M01";
      }
      if ($event.Id == 6)
        this.doituongSelect.LoaiMauS = "Giấy đề nghị thanh toán tạm ứng (C2-03)";
      if ($event.Id == 7)
        this.doituongSelect.LoaiMauS = "Giấy nộp trả kinh phí (C2-05a)";
       
    }
  }




}
